<template>
  <list-layout-two-columns-no-fixed-collapsible :tableTools="false" :custom-right="summaryWidth" :collapsed="collapsed" @update:collapsed="$emit('update:collapsed', $event)">
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
        <el-form ref="ruleForm" class="flex-1" :model="form" :rules="rules">
          <el-form-item prop="invoiceLines">
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template slot="table-core">
      <base-table-pagination-mini v-if="!isLower1650 || isLower1024"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination-mini>
      <base-table-pagination v-else
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100 gap-4">
        <div class="flex flex-row space-x-2">
          <base-button-responsive size="xs" class="w-full md:w-auto" icon="plus" :text="$t('invoices.invoices_issuing.step4.add_line')" @click="toggleImportProducts" :loading="isGeneralLoading" />
        </div>
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags hide-save :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        ref="grid"
        v-model="selected"
        value-key="uuid"
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading="isGeneralLoading"
        :selectedField="selectedField"
        :inEditField="inEditField"
        :inEditDetailField="inEditDetailField"
        :expandField="expandField"
        :update-columns="false"
        :is-row-editable="isRowEditable"
        edit-on-row-click
        @itemchange="onItemChange"
        @datastatechange="dataStateChange">
          <template v-slot:kendorowdetail="{ props, listeners }">
            <step-4-product-detail-row :ref="`detail-row-${props.scope.uuid}`"
              v-bind="props" v-on="listeners"/>
          </template>
      </kendo-grid-component>
    </template>
    <template slot="RightCol">
      <slot name="invoice-summary" />
    </template>
    <template slot="layout-extend">
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <slot name="layout-extend" :valid="!!form.invoiceLines.length" />
      <base-table-select-actions-expand baseDropDownVisible :visibility="hasSelected"
        :selected="rowsSelected" :total="rowsTotal">
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span>
            <base-button-item-list theme="dark" @click="deleteLines">
              <base-icon name="trash" class="mr-2" />
              <div class="w-72 text-left">{{ $t('app.remove') }}</div>
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <import-products-dialog :dialogOpen="ImportProductsDialog" :id-cliente="value" :mobile-version="isLower1024" @toggleDialog="toggleImportProducts" @applyDialog="importProducts" />
    </template>
  </list-layout-two-columns-no-fixed-collapsible>
</template>

<script>
import { i18n } from '@/i18n'

import ListLayoutTwoColumnsNoFixedCollapsible from '@/components/layout/ListLayoutTwoColumnsNoFixedCollapsible.vue'
import FilterPanel from '@/components/filters/Step4Filter.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import ImportProductsDialog from '@/components/Step4ProductsDialog.vue'
import Step4ProductDetailRow from '@/components/Step4ProductDetailRow.vue'

import { getInvoiceLines } from '@/services/app/getInvoiceLines'
import getNestedValue from '@/services/functions/getNestedValue'
import { recalculate } from '@/services/functions/lines/lineCalcs'
import { cloneDeep, isEqual } from 'lodash'

export default {
  name: 'step4-line',
  components: {
    // Loading,
    ListLayoutTwoColumnsNoFixedCollapsible,
    FilterPanel,
    KendoGridComponent,
    ImportProductsDialog,
    Step4ProductDetailRow
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
    summaryWidth: {
      type: [Array, Object, String],
      default: 'w-full'
    },
    collapsed: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      stepId: '4',
      // Searches
      saveSearchDialog: false,
      // All
      ImportProductsDialog: false,
      spanish: true,
      vuexnamespace: 'invoicesIssuing/4',
      selectedField: 'selected',
      inEditField: 'inEdit',
      inEditDetailField: 'inEditDetail',
      expandField: 'expanded',
      additionalLineItemInformationMaxLength: '2500',
      // expand: false,
      // expandedItems: [],
      rules: {
        invoiceLines: [
          {
            required: true,
            message: i18n.t('invoices.invoices_issuing.step4.one_invoice_line_required'),
            trigger: ['blur', 'change']
          }
        ]
      },
      filterPanel: false,
      loadingDataTable: false,
      data: [],
      selected: [],
      inDetailEdit: []
    }
  },
  computed: {
    hasEquivalenceSurcharge: function () {
      return this.$store.getters['invoicesIssuing/2/form']?.applyEquivalenceSurcharge
    },
    hasOperationType: function () {
      return this.operationType === 1 || this.operationType === 2 || this.operationType === 3
    },
    operationType: function () {
      return this.$store.getters['invoicesIssuing/2/form']?.tipoImpuestoFactura
    },
    form: function () {
      return this.$store.getters[this.vuexnamespace + '/form']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    uuidList: function () {
      return this.form.invoiceLines.map(x => x.uuid)
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.kendo.dataResult ? this.kendo.dataResult.data.length : 0
    },
    hasSelected () {
      return this.selected.length > 0
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.loadingCompanies || this.loadingCompanyData || this.loadingContacts
    },
    isIssuingCreation: function () {
      return !!this.$store.getters['app/isInMode'](1)
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isLower1650: function () {
      return this.$store.getters['app/getIsLower1650']
    },
  },
  // watch: {
  //   'form.invoiceLines': {
  //     deep: true,
  //     handler: async function () {
  //       this.data = await this.applyFilters()
  //     }
  //   }
  // },
  async mounted () {
    if (this.isIssuingCreation || this.form.invoiceLines.length === 0) {
      this.toggleImportProducts()
    }
    this.data = await this.applyFilters()
  },
  methods: {
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleImportProducts: function () {
      this.ImportProductsDialog = !this.ImportProductsDialog
    },
    isRowEditable: function (dataItem) {
      return !getNestedValue(this.inEditDetailField, dataItem)
    },
    editDetail: function (dataItem, toEdit) {
      if (toEdit) {
        if (!this.isInDetailEdit(dataItem)) {
          this.inDetailEdit.push(dataItem.uuid)
        }
      } else {
        const index = this.inDetailEdit.indexOf(dataItem.uuid)
        if (index !== -1) {
          this.inDetailEdit.splice(index, 1)
        }
      }
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    getParamsFilter (data) {
      const user = this.$store.getters['auth/user']
      const extraparams = cloneDeep(data)
      Object.entries(extraparams).forEach(([key, value]) => { extraparams[key] = this.discard(['label', 'value'], value) })
      if (this.value && !extraparams.idCliente) {
        extraparams.idCliente = { comparator: 'equals' }
      }
      return {
        idCliente: data.idCliente ? data.idCliente : null,
        idUsuario: user.IdUsuario,
        codProducto: data.codProducto ? data.codProducto.value : null,
        descripcion: data.descripcion ? data.descripcion.value : null,
        cantidad: data.cantidad ? data.cantidad.value : null,
        cantidadMax: data.cantidadMax ? data.cantidadMax.value : null,
        cantidadMin: data.cantidadMin ? data.cantidadMin.value : null,
        precioUnitarioMax: data.precioUnitarioMax ? data.precioUnitarioMax.value : null,
        precioUnitarioMin: data.precioUnitarioMin ? data.precioUnitarioMin.value : null,
        totalMax: data.totalMax ? data.totalMax.value : null,
        totalMin: data.totalMin ? data.totalMin.value : null,
        descuento: data.descuento ? data.descuento.value : null,
        cuota: data.cuota ? data.cuota.value : null,
        extraparams
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = this.getParamsFilter(data)
      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)

      try {
        const data = await this.getItemsData(obj, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }
      return data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getInvoiceLines(orders, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const index = tag.at(-1)
      const tagName = this.multipleFilters.find(x => new RegExp('^' + x.NombreTag + '\\d*$').test(tag[0]))?.NombreTag
      if (tagName) {
        if (Number.isInteger(index) && Array.isArray(filter[tagName].value) && index > -1 && 
          index < filter[tagName]?.value.length && filter[tagName]?.value.length > 1) {
          filter[tagName].value.splice(index, 1)
        } else {
          delete filter[tagName]
        }
      } else {
        delete filter[tag[0]]
      }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    removeAllTagsHandler: async function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    unselect: function () {
      this.selected = []
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        if (valid && doInput && (this.isFirstStep || this.value === '') && [3, 7, 8].includes(this.role)) {
          this.$emit('input', this.form.invoiceLines[0]?.idCliente ?? '')
        }
        callback(valid) 
      })
    },
    resetForm (excluded = []) {
      if (!excluded.includes(this.stepId)) {
        this.$store.dispatch(this.vuexnamespace + '/resetForm')
        this.selected = []
        this.data = []
      }
    },
    handleTax (products) {
      // 1. Mirar si ya existe en el cliente un impuesto No sujeto, Exento o Sujeto Pasivo 
      //  a. Si lo tiene usarlo para todos los productos de la linea
      //  b. Si NO lo tiene crearlo
      // 2. Si se crea un impuesto nuevo vincularlo a todos los productos que tenga en líneas
    },
    importProducts: async function (products) {
      this.$store.commit('setIsLoading', true)
      // if (this.hasOperationType) this.handleTax(products)
      products.forEach(product => {
        this.checkProducts(product)
      })
      this.data = await this.applyFilters()
      this.$store.commit('setIsLoading', false)
    },
    mergeLines: async function (oldElement, newParams) {
      oldElement.cantidad = parseFloat(oldElement.cantidad) + parseFloat(newParams.cantidad)
      recalculate(oldElement, this.hasEquivalenceSurcharge, this.hasOperationType)
      this.data = await this.applyFilters()
    },
    addLine: function (params) {
      try {
        this.$store.commit('setIsLoading', true)
        const linea = {
          ...params,
          uuid: this.generateLineUuid(),
          lineNumber: this.form.invoiceLines.length + 1
        }
        this.form.invoiceLines.push(linea)
        this.validate()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    checkProducts: async function (params) {
      var merged = false
      if (this.form.invoiceLines.length !== 0) {
        // Comprobamos si ya existe ese producto
        if (this.form.invoiceLines.some(element => element.idProducto === params.idProducto)) {
          const ignoredKeys = ['uuid', 'lineNumber', 'cantidad', 'subtotal', 'total', 'Impuestos', 'cuotaRecargo', 'Taxes.0.cuota', 'Taxes.0.cuotaRecargo', 'totalConImpuesto', 'additionalLineItemInformation']
          for (let i = 0; i < params.descuentos.length; i++) {
            const descuento = params.descuentos[i]
            if (descuento.incluyeDescuento !== '') {
              ignoredKeys.push(descuento.incluyeDescuento ? `descuentos.${i}.cuota` : `descuentos.${i}.descuento`)
            }            
          }
          for (const element of this.form.invoiceLines) {
            if (element.idProducto === params.idProducto) {
              if (isEqual(this.discard(ignoredKeys, element), this.discard(ignoredKeys, params))) {
                await this.mergeLines(element, params)
                merged = true
                break
              }
            }
          }
        }
      }
      if (!merged) {
        this.addLine(params)
      }
    },
    deleteLines: async function (event) {
      const selected = Array.isArray(event) ? event : this.selected
      var deleted = false
      for (const uuid of selected) {
        const index = this.form.invoiceLines.findIndex(x => x.uuid === uuid)
        if (index > -1) {
          this.form.invoiceLines.splice(index, 1) // Eliminar
          deleted = true
        }
      }
      if (deleted) {
        this.form.invoiceLines.forEach((x, i) => { x.lineNumber = i + 1 })
        this.data = await this.applyFilters()
      }
      this.unselect()
    },
    generateLineUuid: function () {
      var uuid = ''
      do {
        uuid = crypto.randomUUID()
      } while (this.uuidList.includes(uuid))
      return uuid
    },
    onItemChange: function ({ dataItem, fields = [] } = {}) {
      if (fields.includes('UnitPriceWithoutTax') || fields.includes('cantidad')) {
        recalculate(dataItem, this.hasEquivalenceSurcharge, this.hasOperationType)
      }
      if (dataItem.uuid) {
        const index = this.form.invoiceLines.findIndex(x => dataItem.uuid === x.uuid)
        if (index > -1) {
          this.form.invoiceLines.splice(index, 1, this.discard([this.selectedField, this.inEditField, this.inEditDetailField, this.expandField], dataItem))
        }
      }
    }
  },
}
</script>

<style scoped>
  ::v-deep .el-input__count .dark {
    @apply text-darkblue-100 mt-1;
    background-color: transparent;
  }
  ::v-deep .el-input__count {
    @apply mt-1;
    background-color: transparent;
}

  @media (width < 1630px) {
    ::v-deep .table-tools > :first-child{
      gap: 0.5rem;
      flex-direction: column;
      justify-content: center;
    }
  }

.layout-list-two-columns::v-deep .left-col > .content {
  @apply px-4 lg:px-10
}
</style>
